import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setPreviousPage } from "./utils/analyticsHelpers.ts";
import {
  endLoading,
  startLoading,
  closeMainModal,
  closeNDAModal,
  closeAll,
} from "./store/actions";
import "./App.scss";
import WorkBag from "./pages/WorkBag/WorkBag.tsx";
import JobboardProfileOnboarding from "./pages/WorkBag/JobboardProfileOnboarding.tsx";
import WorkBagSuccess from "./pages/WorkBagSuccess/WorkBagSuccess.tsx";
import MainModalNew from "./components/UI/MainModal/MainModalNew.tsx";
import InviteToRegisterModal from "./components/UI/InviteToRegisterModal/InviteToRegisterModal.tsx";
import FeedTextModal from "./components/UI/FeedModal/FeedTextModal.tsx";
import LoginNew from "./pages/LoginNew/LoginNew.tsx";
import RegisterNewV2 from "./pages/Register/Register.tsx";
import Faq from "./pages/Faq/Faq.tsx";
import Onboarding from "./pages/Onboarding/Onboarding.tsx";
import DashboardFinal from "./pages/Dashboard/DashboardFinal.tsx";
import ProyectosPrivados from "./pages/ObrasPrivadas/PrivateProyects";
import NewPrivateProject from "./pages/ObrasPrivadas/NewPrivateProjectV3.tsx";
import RecuperarPassword from "./pages/RecuperarPassword/RecuperarPassword.tsx";
import CotizacionDeMateriales from "./pages/CotizacionDeMateriales/CotizacionDeMateriales";
import PublicQuotationById from "./components/MarketPlace/PublicQuotations/PublicQuotationByIdV2.tsx";
import PublicProjectById from "./components/Dashboard/PublicProjects/PublicProjectByIdV2.tsx";
import WorkOfferById from "./pages/WorkBag/WorkOfferById.tsx";
import PostularmeNDA from "./pages/Postulaciones/PostularmeNDA/PostularmeNDA";
import SolicitudesPage from "./pages/Solicitudes/SolicitudesPage.tsx";
import ObrasPublicas from "./pages/ObrasPublicas/LicitacionesPublicas";
import PrivateRoute from "./utils/PrivateRoute";
import NewModal from "./components/UI/NewModal/NewModal";
import Vector from "./assets/svg/vectorEdify.svg";
import ForgotPasswordNew from "./pages/ForgotPasswordNew/ForgotPasswordNew.tsx";
import { AnimatePresence } from "framer-motion";
import RegisteredUserProfile from "./components/RegisteredUsers/RegisteredUserProfile.tsx";
import AdjudicatedProjectById from "./components/Dashboard/PublicProjectsAdjudicated/AdjudicatedProjectByIdV2.tsx";
import PeopleSearchPage from "./pages/PeopleSearch/PeopleSearchPage.tsx";
import ProyectoId from "./components/Dashboard/project/ProjectById/ProyectoId";
import OfertaDeTrabajo from "./pages/MercadoDeTrabajo/OfertaDeTrabajo.tsx";
import WorkOffersInternal from "./pages/MercadoDeTrabajo/WorkOffersInternal.tsx";
import WorkOfferInternalView from "./pages/MercadoDeTrabajo/WorkOfferInternalView.tsx";
import NotFound from "./pages/NotFound/NotFound";
import InvitePage from "./pages/InvitePage/InvitePage.tsx";
import OAuthCallback from "./pages/ProjectDocumentation/OAuthCallback.tsx";
import ProjectDocumentationEdit from "./pages/ProjectDocumentation/ProjectDocumentationEdit.tsx";
import SubscriptionModalRouter from "./components/UI/SubscriptionModalRouter/SubscriptionModalRouter.tsx";
import SendContactModal from "./components/UI/ContactModal/SendContactModal.tsx";
import CalificationModal from "./components/UI/CalificationModal/CalificationModal.tsx";
import WelcomeTour from "./components/WelcomeTour/WelcomeTour.tsx";
import EdifySpinner from "./components/UI/Loading/SpinnerEdify";
import LoaderAnimation from "./components/UI/LoaderAnimation/LoaderAnimation.tsx";
import { initMercadoPago } from "@mercadopago/sdk-react";
import BackofficeLayout from "./components/backOffice/BackofficeLayout.tsx";
import PhotoUploadModal from "./components/FileUpload/PhotosUploadModal";
import Cotizaciones from "./pages/Cotizaciones/Cotizaciones";
import QuotationDetails from "./components/MarketPlace/Cotizaciones/QuotationDetails";
import CotizadorNew from "./components/MarketPlace/CotizadorDeMateriales/CotizadorNew.tsx";
import WorkRequest from "./pages/WorkBag/WorkRequest";
import ProjectDocumentationNew from "./pages/ProjectDocumentation/ProjectDocumentationNew.tsx";
import MarketplaceExplorar from "./pages/MarketplaceExplorar/MarketplaceExplorar.tsx";
import ProductoForm from "./pages/Productos/ProductoForm.tsx";
import environment from "./environments/index";
import { useSessionTimeout } from "./hooks/useSessionTimeout.ts";
import SessionWarning from "./components/SessionWarning/SessionWarning.tsx";


// Initialize Mercado Pago before everything else
const MP_PUBLIC_KEY = environment.mercadoPago.publicKey;
initMercadoPago(MP_PUBLIC_KEY);

const App = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Session timeout management
  const { showWarning, timeLeft, extendSession, onClose } = useSessionTimeout();
  

  useEffect(() => {
    
    const handleDOMContentLoaded = () => {
      props.startLoading();
    };
  
    const handleLoad = () => {
      props.endLoading();
    };
  
    if (document.readyState === 'loading') {
      window.addEventListener("DOMContentLoaded", handleDOMContentLoaded);
      window.addEventListener("load", handleLoad);
    } else {
      handleDOMContentLoaded();
      handleLoad();
    }
  
    return () => {
      window.removeEventListener("DOMContentLoaded", handleDOMContentLoaded);
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  useEffect(() => {
    props.closeMainModal();
  }, [props.closeMainModal]);

  useEffect(() => {
    document.body.style.overflow = props.newModalOpen ? "hidden" : "unset";
  }, [props.newModalOpen]);

  useEffect(() => {
    const currentPath = location.pathname;
    const storedPrevious = sessionStorage.getItem('edify_analytics_previous_page');
    
    if (storedPrevious && storedPrevious !== currentPath) {
      setPreviousPage(storedPrevious);
    }
    
    sessionStorage.setItem('edify_analytics_previous_page', currentPath);
  }, [location.pathname]);

  const checkPathIncludes = (route) => location.pathname.includes(route);


  const goBack = () => {
    props.closeAll();
    navigate("/");
  };

  let isDashboard = checkPathIncludes("dashboard");

  return (
    <div>
      <AnimatePresence mode="wait">
        <Routes>
          <Route
            path="/obra-publica-a-licitar/:id"
            element={
              <PrivateRoute
                element={PublicProjectById}
                isPremiumContent={true}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/buscar-perfiles"
            element={
              <PrivateRoute
                element={PeopleSearchPage}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/perfil/:id"
            element={
              <PrivateRoute
                element={RegisteredUserProfile}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/materiales-a-licitar-publicos/:id"
            element={
              <PrivateRoute
                element={PublicQuotationById}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/obraspublicas/proyectos-adjudicados/:id"
            element={
              <PrivateRoute
                element={AdjudicatedProjectById}
                hasLayout={true}
                isAdjudicated
              />
            }
          />
          <Route
            path="/faq"
            element={
              <PrivateRoute
                element={Faq}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute
                element={DashboardFinal}
                hasLayout={false}
                isDashboard={isDashboard}
              />
            }
          />
          <Route
            path="/marketplace/explorar"
            element={
              <PrivateRoute
                element={MarketplaceExplorar}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/obrasprivadas"
            element={
              <PrivateRoute
                element={ProyectosPrivados}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/obrasprivadas/explorar"
            element={
              <PrivateRoute
                element={ProyectosPrivados}
                hasLayout={true}
                showList={true}
              />
            }
          />
          <Route
            path="/obrasprivadas/crear"
            element={
              <PrivateRoute
                element={NewPrivateProject}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/obrasprivadas/edit/:id"
            element={
              <PrivateRoute
                element={NewPrivateProject}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/obrasprivadas/:id"
            element={
              <PrivateRoute
                element={ProyectoId}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/documentacion-de-obra/crear"
            element={
              <PrivateRoute
                element={ProjectDocumentationNew}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/documentacion-de-obra/edit/:id"
            element={
              <PrivateRoute
                element={ProjectDocumentationEdit}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/documentacion-de-obra/oauth-callback"
            element={
              <PrivateRoute
                element={OAuthCallback}
                hasLayout={false}
              />
            }
          />
          <Route
            path="/productos/crear"
            element={
              <PrivateRoute
                element={ProductoForm}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/productos/edit/:id"
            element={
              <PrivateRoute
                element={ProductoForm}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/obraspublicas"
            element={
              <PrivateRoute
                element={ObrasPublicas}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/cotizaciondemateriales"
            element={
              <PrivateRoute
                element={CotizacionDeMateriales}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/cotizaciondemateriales/explorar"
            element={
              <PrivateRoute
                element={CotizacionDeMateriales}
                hasLayout={true}
                showListView={true}
              />
            }
          />
          <Route
            path="/cotizaciondemateriales/crear"
            element={
              <PrivateRoute
                element={Cotizaciones}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/cotizaciondemateriales/estimacion-costos"
            element={
              <PrivateRoute
                element={Cotizaciones}
                hasLayout={true}
              />
            }
          />
           <Route
            path="/cotizaciondemateriales/:id"
            element={
              <PrivateRoute
                element={QuotationDetails}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/cotizaciondemateriales/edit/:id"
            element={
              <PrivateRoute
                element={Cotizaciones}
                hasLayout={true}
              />
            }
            />
             <Route
            path="/cotizaciondemateriales/postulante/:quotationId"
            element={
              <PrivateRoute
                element={CotizadorNew}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/notificaciones"
            element={
              <PrivateRoute
                element={SolicitudesPage}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/mercado-de-trabajo/crearoferta"
            element={
              <PrivateRoute
                element={OfertaDeTrabajo}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/backoffice"
            element={
              <PrivateRoute
                element={BackofficeLayout}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/onboarding"
            element={<Onboarding />}
          />
          <Route
            path="/bolsa-trabajo/:id"
            element={
              <PrivateRoute
                element={WorkOfferInternalView}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/bolsa-trabajo"
            element={
              <PrivateRoute
                element={WorkOffersInternal}
                hasLayout={true}
              />
            }
          />
          <Route
            path="/bolsadetrabajo"
            element={<WorkBag />}
          />
          <Route
            path="/bolsadetrabajo/registro-exitoso"
            element={<WorkBagSuccess />}
          />
          <Route
            path="/bolsadetrabajo/completar-perfil"
            element={
              <PrivateRoute
                element={JobboardProfileOnboarding}
                hasLayout={false}
              />
            }
          />
          <Route
            path="/creartrabajo"
            element={<WorkRequest />}
          />
          <Route
            path="/bolsadetrabajo/:id"
            element={<WorkOfferById />}
          />
          <Route
            path="/register"
            element={<RegisterNewV2 />}
          />
          <Route
            path="/forgotpassword"
            element={<ForgotPasswordNew />}
          />
          <Route
            path="/recovery/:token"
            element={<RecuperarPassword />}
          />
          <Route
            path="/invite"
            element={<InvitePage />}
          />
          <Route
            path="/"
            element={<LoginNew />}
          />
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </AnimatePresence>
             {props.openMainModal && <MainModalNew />}
      {props.inviteToRegisterModal &&
        props.inviteToRegisterModal.open && <InviteToRegisterModal />}
      {props.openFeedTextModal && <FeedTextModal />}
      {props.openNDAModal && (
        <PostularmeNDA
          opened={props.openNDAModal}
          closeModal={props.closeNDAModal}
        />
      )}
      {props.newModalOpen && (
        <NewModal
          icon={Vector}
          title={"Error de verificación"}
          description={
            "El token ha expirado. Por favor, vuelva a enviar la verificación"
          }
          buttonSend={{
            title: "Volver a enviar",
            onClick: this.sendAgain,
          }}
          buttonBack={{
            title: "Volver al inicio",
            onClick: goBack,
          }}
        />
      )}
      <SubscriptionModalRouter />
      {props.showSendContactNotificationModal.isOpen && (
        <SendContactModal />
      )}
      {props.calificationModal.isOpen && <CalificationModal />}
      <WelcomeTour />
      {props.edifySpinner && <EdifySpinner />}
      {props.identityModal.isOpen && <PhotoUploadModal />}
      {/* Loader Animation para Login y Logout */}
      <LoaderAnimation isActive={props.loginAnimation} type={props.loginAnimationType || "login"} />
      <LoaderAnimation isActive={props.logoutAnimation} type="logout" />
      
      {/* Session Warning Modal */}
      <SessionWarning 
        isOpen={showWarning}
        timeLeft={timeLeft}
        onExtendSession={extendSession}
        onClose={onClose}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuth: state.general.isAuth,
    openMainModal: state.general.openMainModal,
    inviteToRegisterModal: state.general.inviteToRegisterModal,
    openFeedTextModal: state.general.openFeedTextModal,
    openNDAModal: state.general.openNDAModal,
    newModalOpen: state.general.newModalOpen,
    showSendContactNotificationModal: state.general.showSendContactNotificationModal,
    calificationModal: state.general.calificationModal,
    tutorialModal: state.dashboard.tutorialModal,
    edifySpinner: state.general.edifySpinner,
    identityModal: state.register.identityModal,
    loginAnimation: state.general.loginAnimation,
    loginAnimationType: state.general.loginAnimationType,
    logoutAnimation: state.general.logoutAnimation,
  };
};

export default connect(mapStateToProps, {
  startLoading,
  endLoading,
  closeMainModal,
  closeNDAModal,
  closeAll,
})(App);
